
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":"13","width":"32","height":"5","rx":"2.5"}}),_c('rect',{attrs:{"y":"3","width":"32","height":"5","rx":"2.5"}}),_c('rect',{attrs:{"y":"23","width":"32","height":"5","rx":"2.5"}})])
          )
        }
      }
    